import { JCalProjectCategoryDTO } from 'src/services/project/dto/JCalProjectDTO';

export enum JCalProjectCategory {
    SOFTWARE = 'software',
    BUILD = 'build',
}

export namespace JCalProjectCategory {
    export function fromDTO(category: JCalProjectCategoryDTO): JCalProjectCategory {
        switch (category) {
            case 'software': return JCalProjectCategory.SOFTWARE;
            default: return JCalProjectCategory.BUILD;
        }
    }

    /** The section heading, e.g. "Builds". */
    export function label(category: JCalProjectCategory): string {
        return category === JCalProjectCategory.SOFTWARE ? 'Software' : 'Builds';
    }

    /** The singular noun, e.g. "build". */
    export function noun(category: JCalProjectCategory): string {
        return category === JCalProjectCategory.SOFTWARE ? 'software project' : 'build';
    }
}
